/** Web copy of src/shared/productLinks.ts: the web bundle cannot import from src/ at runtime.
 *  tests/contract/webMirrorContracts.test.ts keeps the body byte-identical to the source. */
export const SUPPORT_URL = 'https://coresynth.io';
